<div class="tw-w-full tw-fixed tw-inset-0 tw-z-30">
  <div class="tw-w-screen tw-h-screen tw-flex tw-justify-center tw-items-center tw-relative">
    @if (!scratchCardData.isScratched) {
      <img class="tw-w-full tw-h-[45%] tw-object-cover tw-top-0 tw-absolute tw-z-50" src="https://cdn.cureskin.com/app/img/gamification/confetti_large.gif" alt="confetti">
    }

    <div class="tw-w-[90%] tw-h-[58vh] tw-rounded-6 tw-relative tw-z-40 tw-bg-top tw-flex tw-justify-center tw-items-center tw-bg-opacity-40" style="background-image: url('https://cdn.cureskin.com/app/img/gamification/gamification_bg_2.png')">
      @if (scratchCardData.isScratched) {
        <img class="tw-w-full tw-h-full tw-object-cover tw-left-0 tw-right-0 tw-top-1/2 -tw-translate-y-1/2 -tw-mt-5 tw-absolute tw-z-0" src="https://cdn.cureskin.com/app/img/gamification/confetti.gif" alt="confetti">
      }
      @if (!scratchCardData.isScratched) {
        <div class="tw-absolute tw-w-fit tw-top-0 tw-left-1/2 -tw-translate-x-1/2 tw-py-2 tw-px-4 tw-bg-teal-500 tw-bg-gradient-light-teal-to-teal tw-rounded-b-4 tw-text-white tw-text-200 tw-font-bold tw-flex tw-items-center tw-gap-2 tw-mb-4 tw-font-lexend">
          <img src="/assets/icons/gift.svg" alt="gift-icon">
          <span i18n="@@rewardUnlocked">Reward Unlocked</span>
        </div>
      }
      <div class="tw-w-full tw-flex tw-flex-col tw-justify-center tw-items-center tw-font-lexend">
        <h1 [ngClass]="!scratchCardData.isScratched ? 'tw-mb-1.5' : 'tw-mb-7'" class="tw-font-extrabold tw-text-700 -tw-tracking-[1.5px]" i18n="@@congrats">Congratulations!</h1>
        @if (!scratchCardData.isScratched) {
          <p class="tw-text-300 tw-text-gray-500 tw-font-normal tw-mb-5" i18n="@@youHaveCompletedChallenge">You have completed the Challenge</p>
        }
        @if (!scratchCardData.isScratched) {
          <p class="tw-text-200 tw-text-gray-600 tw-font-bold tw-mb-4" i18n="@@scratchToReveal">Scratch to reveal your reward</p>
        }
        <div class="tw-w-44 tw-aspect-square tw-rounded-4 tw-relative tw-overflow-hidden">
          <!-- White background with reward amount (revealed when scratched) -->
          <div class="tw-absolute tw-inset-0 tw-bg-white tw-flex tw-flex-col tw-justify-center tw-items-center tw-rounded-3 tw-z-10 tw-shadow-z4" [class.tw-invisible]="!isCanvasReady && !scratchCardData.isScratched">
            <img class="tw-w-14" src="/assets/icons/cureskin_cash.svg" alt="gift translucent">
            @if (rewardData?.amount || scratchCardData.rewardAmount) {
              <h1 class="tw-font-extrabold tw-text-[60px] tw-leading-none -tw-tracking-[1.5px]">
                ₹{{ rewardData?.amount || scratchCardData.rewardAmount }}
              </h1>
            }
          </div>
          <!-- Placeholder gradient background (shown while canvas loads) -->
          @if (!isCanvasReady) {
            <div class="tw-absolute tw-inset-0 tw-bg-gradient-to-br tw-from-teal-600 tw-to-teal-400 tw-rounded-3 tw-z-20"></div>
          }
          <!-- Scratchable canvas overlay (teal gradient with gift icon) -->
          <canvas #scratchCanvas
            class="tw-absolute tw-inset-0 tw-w-full tw-h-full tw-rounded-3 tw-cursor-pointer tw-z-20"
            style="touch-action: none;"
            [class.tw-pointer-events-none]="scratchCardData.isScratched"
            [class.tw-opacity-0]="!isCanvasReady">
          </canvas>
        </div>
        <!-- Expiry and CTA (shown after scratching) -->
        @if (scratchCardData.isScratched) {
          <div class="tw-w-full tw-flex tw-flex-col tw-items-center tw-mt-5 tw-font-bold tw-font-lexend tw-relative tw-z-10">
            <p class="tw-text-300 tw-font-bold tw-text-gray-500 tw-mb-6" i18n="@@youHaveWonCureskinCash">You've won ₹{{ rewardData?.amount || scratchCardData.rewardAmount }} worth Cure cash</p>
            <div (click)="shopNow()"
              class="tw-bg-teal-600 tw-text-white tw-font-bold tw-text-500 tw-w-[90%] tw-py-3 tw-rounded-3 tw-flex tw-justify-center tw-items-center"
              i18n="@@shopNow"
            >Shop Now</div>
          </div>
        }
      </div>
    </div>

    <div class="tw-w-full tw-h-full tw-bg-black tw-opacity-80 tw-absolute"
      [class.tw-pointer-events-none]="scratchCardData.isScratched"
    (click)="!scratchCardData.isScratched && closeScratchCard()"></div>
  </div>
</div>
